export const MobileCallSurfaceTestIds = {
  ROOT: 'mobile-call-surface.root',
};
